export const changeFetchInProg = fetchInProgress => ({
  type: "CHNAGE_PROGRESS",
  fetchInProgress
});
